import axios, { AxiosResponse } from 'axios';
import { loadConfig } from '@api/api';

const getJobQueuesApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/jobqueue`;
};

const getAnalysisTypeDefault = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/analysisType/default`;
};
const getAnalysisTypeURL = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/analysisType`;
};
const get_api = async ({
  url,
  accessToken,
  parameter = undefined,
}: {
  url: string;
  accessToken: string;
  parameter?: any;
}) => {
  const axios_response: AxiosResponse = await axios(`${url}`, {
    method: 'get',
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
    params: parameter !== undefined ? parameter : {},
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
  return axios_response;
};

const ReRunByJobQueue = async ({
  seriesid = '6930f092365fd8b58bff8e16',
  accessToken,
  kind,
  isDefault = true,
  isSkipDependency = false,
}: {
  seriesid: string;
  accessToken: string;
  kind: string;
  isDefault?: boolean;
  isSkipDependency?: boolean;
}) => {
  if (!seriesid) return null;
  const QUEUES_API = await getJobQueuesApi();
  let ayt: AxiosResponse;
  let job_id: string;
  if (isDefault) {
    const ANALYSISTYPE_API = await getAnalysisTypeDefault();
    ayt = await get_api({ url: ANALYSISTYPE_API, accessToken });
  } else {
    const ANALYSISTYPE_API = await getAnalysisTypeURL();
    ayt = await get_api({
      url: ANALYSISTYPE_API,
      accessToken,
      parameter: {
        filterOptions: JSON.stringify({ name: kind }),
      },
    });
  }
  console.log(ayt);
  if (!(ayt.status === 200 || ayt.status === 201)) return ayt;

  if (isDefault) {
    if (!ayt.data?.id) {
      throw new Error('Default analysis type was not found.');
    }
    job_id = ayt.data.id;
  } else {
    const analysisType = Array.isArray(ayt.data) ? ayt.data[0] : undefined;
    if (!analysisType?.id) {
      throw new Error(`Analysis type "${kind}" was not found.`);
    }
    job_id = analysisType.id;
  }

  const res: AxiosResponse<[]> = await axios(`${QUEUES_API}`, {
    method: 'post',
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
    data: {
      priority: 1000,
      job: {
        status: 'Pending',
        kind: kind,
        analysisBase: {
          series: [seriesid],
          analysisType: job_id,
        },
      },
      isRerun: true,
      isSkipDependencyOnRerun: isSkipDependency,
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  return res;
};

export const ReSegmentation = async ({
  seriesid = '6930f092365fd8b58bff8e16',
  accessToken,
}: {
  seriesid: string;
  accessToken: string;
}) => {
  if (!seriesid) return null;
  return await ReRunByJobQueue({
    seriesid,
    accessToken,
    kind: 'Segmentation',
    isDefault: true,
  });
};
export const ReCTFFR = async ({
  seriesid = '6930f092365fd8b58bff8e16',
  accessToken,
}: {
  seriesid: string;
  accessToken: string;
}) => {
  if (!seriesid) return null;
  return await ReRunByJobQueue({
    seriesid,
    accessToken,
    kind: 'ct-ffr',
    isDefault: false,
    isSkipDependency: true,
  });
};

export const ReGenerate_data = async ({
  seriesid = '6930f092365fd8b58bff8e16',
  accessToken,
}: {
  seriesid: string;
  accessToken: string;
}) => {
  if (!seriesid) return null;
  return await ReRunByJobQueue({
    seriesid,
    accessToken,
    kind: 'data-generator',
    isDefault: false,
    isSkipDependency: true,
  });
};

export const getJobQueues = async ({
  accessToken,
}: {
  accessToken: string;
}) => {
  const QUEUES_API = await getJobQueuesApi();
  const res: AxiosResponse<[]> = await get_api({
    url: QUEUES_API,
    accessToken,
    parameter: { limit: 0 },
  });

  console.log(res.data);
  return res;
};

export const getAnalysisDefault = async ({
  accessToken,
}: {
  accessToken: string;
}) => {
  const ANALYSISTYPE_API = await getAnalysisTypeURL();
  const res = await get_api({
    url: ANALYSISTYPE_API,
    accessToken,
    parameter: {
      filterOptions: JSON.stringify({ name: 'default', withDefine: true }),
    },
  });
  return res;
};

export const getAnalysisType = async ({
  accessToken,
  id,
}: {
  accessToken: string;
  id: string;
}) => {
  const ANALYSISTYPE_API = await getAnalysisTypeURL();
  const res = await get_api({ url: `${ANALYSISTYPE_API}/${id}`, accessToken });
  return res;
};

export const getServerState = async ({
  accessToken,
}: {
  accessToken: string;
}) => {
  const analysisDefault = await getAnalysisDefault({ accessToken });

  const dependencies = analysisDefault.data?.[0]?.dependency ?? [];

  const types = await Promise.all(
    dependencies.map(async (item: string) => {
      const type = await getAnalysisType({ accessToken, id: item });
      return type.data.name;
    })
  );

  console.log(types);
  return types;
};
